import gql from 'graphql-tag'

export const UPDATE_FAVORITE_LIST = gql`
  mutation UpdateFavoriteList(
    $favoriteListId: Int
    $favoriteListName: String!
    $productErpIdentifier: String!
    $quantity: Int!
    $cartItemId: Int
    $comment: String
  ) {
    updateFavoriteListWithProduct(
      favoriteListId: $favoriteListId
      favoriteListName: $favoriteListName
      productErpIdentifier: $productErpIdentifier
      quantity: $quantity
      cartItemId: $cartItemId
      comment: $comment
    ) {
      productListId
      productListItemId
    }
  }
`
